import * as React from 'react';
import bindAllOfThis from 'src/utils/BindThisHelper';
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from 'src/games/DesertTerraformGame/scenes/GameIntro';

interface PhaserTerraformGameProps {
    onComplete: () => void;

}

interface PhaserTerraformGameState {
}

const gameConfig: GameConfig = {
    title: "Landscaping Game",
    version: "0.9.3",
    backgroundColor: "#000000"
};

class PhaserTerraformGame extends React.Component<PhaserTerraformGameProps, PhaserTerraformGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserTerraformGameProps) {
        super(props);
        bindAllOfThis(this, PhaserTerraformGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig} onComplete={this.props.onComplete}/>
        </div>);
    }
}

export default PhaserTerraformGame;



// WEBPACK FOOTER //
// ./src/games/DesertTerraformGame/Main.tsx